/* Small, independent controller for the Yellow Melons campaign hero. */
(() => {
  if (window.YMEditorialSliderLoaded) return;
  window.YMEditorialSliderLoaded = true;

  function mount(root) {
    if (root.dataset.ymMounted === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-ym-slide]'));
    if (!slides.length) return;
    root.dataset.ymMounted = 'true';

    const previous = root.querySelector('[data-ym-prev]');
    const next = root.querySelector('[data-ym-next]');
    const counter = root.querySelector('[data-ym-current]');
    const pause = root.querySelector('[data-ym-pause]');
    let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer;
    let touchX = null;
    let touchY = null;
    let paused = false;
    const delay = Number(root.dataset.autoplay) * 1000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function show(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        const active = position === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = undefined;
    }

    function start() {
      stop();
      if (slides.length > 1 && delay >= 1000 && !paused && !root.matches(':focus-within, :hover') && !reducedMotion.matches && !window.Shopify?.designMode) {
        timer = window.setInterval(() => {
          if (!document.hidden) show(index + 1);
        }, delay);
      }
    }

    previous?.addEventListener('click', () => { show(index - 1); start(); });
    next?.addEventListener('click', () => { show(index + 1); start(); });
    pause?.addEventListener('click', () => {
      paused = !paused;
      pause.setAttribute('aria-pressed', String(paused));
      pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      pause.textContent = paused ? '▶' : 'Ⅱ';
      start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', event => {
      if (!root.contains(event.relatedTarget)) start();
    });
    root.addEventListener('touchstart', event => {
      touchX = event.changedTouches[0]?.clientX ?? null;
      touchY = event.changedTouches[0]?.clientY ?? null;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', event => {
      if (touchX === null) return;
      const delta = (event.changedTouches[0]?.clientX ?? touchX) - touchX;
      const vertical = (event.changedTouches[0]?.clientY ?? touchY) - touchY;
      touchX = null;
      touchY = null;
      if (Math.abs(delta) > 55 && Math.abs(delta) > Math.abs(vertical) * 1.25) show(index + (delta < 0 ? 1 : -1));
      start();
    }, { passive: true });
    root.addEventListener('shopify:block:select', event => {
      const selected = slides.findIndex(slide => slide.contains(event.target) || slide === event.target);
      if (selected >= 0) { show(selected); stop(); }
    });
    function onUnload(event) {
      if (!event.target?.contains(root)) return;
      stop();
      document.removeEventListener('shopify:section:unload', onUnload);
      reducedMotion.removeEventListener?.('change', start);
    }
    document.addEventListener('shopify:section:unload', onUnload);
    reducedMotion.addEventListener?.('change', start);
    show(index);
    start();
  }

  function mountAll(scope = document) {
    if (scope.matches?.('[data-ym-slider]')) mount(scope);
    scope.querySelectorAll?.('[data-ym-slider]').forEach(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountAll(), { once: true });
  else mountAll();
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
